import { render, staticRenderFns } from "./DashboardNodeRenderer.vue?vue&type=template&id=2958aae2"
import script from "./DashboardNodeRenderer.vue?vue&type=script&lang=js"
export * from "./DashboardNodeRenderer.vue?vue&type=script&lang=js"
import style0 from "./DashboardNodeRenderer.vue?vue&type=style&index=0&id=2958aae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports